import Dashboard from '../components/Dashboard'
import Login from '../components/LoginOnlyDefault'
import AwaitingApproval from '../components/AwaitingApproval'
import NotFound from '../components/NotFound'
import Forbidden from '../components/Forbidden'

import subIndex from '@/content/index'

import store from '../state'

export default [
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            authRequired: true
        },
        children: [
            {
                path: 'yleista',
                component: () => import('@/content/kaikki/yleista'),
                alias: '/',
                name: 'yleista'
            },
            {
                path: 'rangaistustaulukko',
                component: () => import('@/content/kaikki/rangaistustaulukko')
            },
            {
                path: 'rank',
                component: subIndex,
                children: [
                    {
                        path: 'moderator',
                        alias: '/moderaattori',
                        component: () => import('@/content/rank/moderator'),
                        meta: {
                            rankRequired: 'moderaattori'
                        }
                    },
                    {
                        path: 'rakentaja',
                        alias: '/builder',
                        component: () => import('@/content/rank/rakentaja'),
                        meta: {
                            rankRequired: 'rakentaja'
                        }
                    },
                    {
                        path: 'operator',
                        alias: '/operaattori',
                        component: () => import('@/content/rank/operator'),
                        meta: {
                            rankRequired: 'operaattori'
                        }
                    },
                    {
                        path: 'admin',
                        alias: '/admini',
                        component: () => import('@/content/rank/admin'),
                        meta: {
                            rankRequired: 'admin'
                        }
                    },
                    {
                        path: 'omistaja',
                        alias: '/owner',
                        component: () => import('@/content/rank/omistaja'),
                        meta: {
                            rankRequired: 'omistaja'
                        }
                    }
                ]
            },
            {
                path: 'oppaat',
                component: subIndex,
                children: [
                    {
                        path: 'Rangaistukset',
                        component: () => import('@/content/oppaat/rangaistukset')
                    },
                    {
                        path: 'Alueet',
                        component: () => import('@/content/oppaat/alueet')
                    }
                ]
            },
            {
                path: 'pluginit',
                component: subIndex,
                children: [
                    {
                        path: 'coreprotect',
                        component: () => import('@/content/pluginit/coreprotect')
                    },
                    {
                        path: 'worldguard',
                        component: () => import('@/content/pluginit/aluesuojaus')
                    }
                ]
            },
            {
                path: 'muut',
                component: subIndex,
                children: [
                    {
                        path: 'discordbot',
                        component: () => import('@/content/muut/discordbot')
                    }
                ]
            },
            {
                name: 'forbidden',
                component: Forbidden,
                path: 'forbidden'
            },
            {
                path: '*',
                component: NotFound
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/awaiting',
        name: 'awaiting approval',
        component: AwaitingApproval,
        beforeEnter: (to, from, next) => {
            if (store.getters['auth/loggedIn'] && !store.getters['auth/admin']) {
                return store.dispatch('auth/validate').then((validUser) => {
                    validUser ? next() : next({ name: 'login', query: { redirectFrom: to.fullPath } })
                })
            } else {
                next({ name: 'login', query: { redirectFrom: to.fullPath } })
            }
        }
    }
]
